export default __webpack_public_path__ + "static/booker-1cefda95a2ad0f2fb09a2050f7fdce0a.png";